import CountryUtil from "../utils/CountryUtil";
export const showIFrame = (window: any | null | undefined): boolean => {
	if (window) {
		const country: string = CountryUtil.getCountry();
		const tagPrisonCountriesEnv: string = window.tag_prison_countries || "";
		const tagPrisonCountries: Array<string> = tagPrisonCountriesEnv.split(",");
		const iFrameDomain: string | null | undefined = window.tag_prison_domain;
		return !!iFrameDomain && tagPrisonCountries.includes(country) && window.user_has_agreed_to_be_tracked;
	} else {
		return false;
	}
};
export const getIFrameDomain = (window: any | null | undefined): string => {
	if (window) {
		const country: string = CountryUtil.getCountry();
		const iFrameDomain: string = window.tag_prison_domain || "";
		return "//" + country.toLowerCase() + "." + iFrameDomain + "/explore.tagprison.v1/index.html";
	} else {
		return "";
	}
};
